<div class="container-spinner d-flex justify-content-center align-items-center">
    <div class="spinner-border text-success" role="status">
        <span class="visually-hidden">{{"BLOCK.SPINNER.LOADING" | translate}}</span>
      </div>
</div>